import PropTypes from 'prop-types'

export default PropTypes.shape({
  add: PropTypes.func,
  contains: PropTypes.func,
  create: PropTypes.func,
  createModel: PropTypes.func,
  destroy: PropTypes.func,
  getById: PropTypes.func,
  isModel: PropTypes.func,
  load: PropTypes.func,
  openById: PropTypes.func,
  remove: PropTypes.func,
  save: PropTypes.func,
  setCurrent: PropTypes.func,
  toJSON: PropTypes.func,
  unsetCurrent: PropTypes.func,
})



// WEBPACK FOOTER //
// ./src/shared/store-proptypes.js